var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.11111H18M10.5 11.2222V15.8889M13.5 11.2222V15.8889M6.75 8.11111L7.5 17.4444C7.5 17.857 7.65804 18.2527 7.93934 18.5444C8.22064 18.8361 8.60218 19 9 19H15C15.3978 19 15.7794 18.8361 16.0607 18.5444C16.342 18.2527 16.5 17.857 16.5 17.4444L17.25 8.11111M9.75 8.11111V5.77778C9.75 5.5715 9.82902 5.37367 9.96967 5.22781C10.1103 5.08194 10.3011 5 10.5 5H13.5C13.6989 5 13.8897 5.08194 14.0303 5.22781C14.171 5.37367 14.25 5.5715 14.25 5.77778V8.11111",
    stroke: "#787878",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.fa4ef394c4330b30f09d4850ba21d397.svg";
export { ForwardRef as ReactComponent };